import { createContext, ReactNode, useContext, useMemo, useState } from "react";

const DEFAULT_COUNT = 5;
const DEFAULT_TEXT = "Bullet point";

type ThemeBulletPointsContextValue = {
  count: number;
  setCount: (count: number) => void;
  baseText: string;
  setBaseText: (text: string) => void;
  bulletPoints: string[];
};

const ThemeBulletPointsContext =
  createContext<ThemeBulletPointsContextValue | null>(null);

export const ThemeBulletPointsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [count, setCount] = useState(DEFAULT_COUNT);
  const [baseText, setBaseText] = useState(DEFAULT_TEXT);

  const bulletPoints = useMemo(
    () => Array.from({ length: count }, (_, i) => `${baseText} ${i + 1}`),
    [count, baseText]
  );

  return (
    <ThemeBulletPointsContext.Provider
      value={{ count, setCount, baseText, setBaseText, bulletPoints }}
    >
      {children}
    </ThemeBulletPointsContext.Provider>
  );
};

export const useThemeBulletPoints = () => useContext(ThemeBulletPointsContext);
